"use client";

import { useEffect } from "react";
import Script from "next/script";

import "./facebook-video.css";

export default function VideoSection() {
  useEffect(() => {
    if (window.FB) {
      window.FB.XFBML.parse();
    }
  }, []);

  return (
    <div className="home-video">
      <Script
        src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v25.0"
        strategy="afterInteractive"
        crossOrigin="anonymous"
        onLoad={() => {
          if (window.FB) {
            window.FB.XFBML.parse();
          }
        }}
      />

      <div id="fb-root" />

      <div className="container">
        <div className="row">
          
          {/* VIDEO 1 */}
          <div className="col-md-6">
            <div className="single-home-video">
              <div
                className="fb-video"
                data-href="https://www.facebook.com/reel/601156138054580"
                data-app-id="887156172104257"
              />
            </div>
          </div>

          {/* VIDEO 2 */}
          <div className="col-md-6">
            <div className="single-home-video">
              <div
                className="fb-video"
                data-href="https://www.facebook.com/reel/543485238784650"
                data-app-id="887156172104257"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}